if (!customElements.get('antiguo-showcase')) {
  customElements.define('antiguo-showcase', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.cards = Array.from(this.querySelectorAll('template[data-showcase-card]'));
      this.slots = Array.from(this.querySelectorAll('.antiguo-showcase__slot'));
      if (!this.cards.length || !this.slots.length) return;

      const initialOrder = this.shuffle(this.cards.map((_, index) => index));
      this.visible = initialOrder.slice(0, this.slots.length);
      this.roundSeen = new Set(this.visible);
      this.deck = initialOrder.slice(this.slots.length);
      this.turn = 0;
      this.busy = false;
      this.held = false;
      this.slots.forEach((slot, slotIndex) => {
        const cardIndex = this.visible[slotIndex];
        if (cardIndex === undefined) return;
        slot.replaceChildren(this.cloneCard(cardIndex));
        slot.dataset.showcaseIndex = String(cardIndex);
      });

      this.copy = this.closest('.antiguo-shop-welcome')?.querySelector('.antiguo-shop-welcome__copy');
      this.layoutObserver = new ResizeObserver(() => {
        if (!this.copy || window.matchMedia('(max-width: 749px)').matches) return;
        const copyHeight = this.copy.getBoundingClientRect().height;
        const tileWidth = Math.max(220, Math.round((copyHeight - 16) * 2 / 3));
        this.closest('.antiguo-shop-welcome')?.style.setProperty('--showcase-width', `${tileWidth}px`);
      });
      if (this.copy) this.layoutObserver.observe(this.copy);

      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.held = true; }, options);
      this.addEventListener('pointerleave', () => { this.held = false; }, options);
      if (this.cards.length > this.slots.length) {
        this.timer = window.setInterval(() => this.change(), 5000);
      }
    }

    shuffle(values) {
      const result = [...values];
      for (let index = result.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [result[index], result[randomIndex]] = [result[randomIndex], result[index]];
      }
      return result;
    }

    cloneCard(index) {
      return this.cards[index].content.querySelector('.antiguo-showcase__card').cloneNode(true);
    }

    nextCardIndex() {
      const allIndexes = this.cards.map((_, index) => index);
      if (this.roundSeen.size >= allIndexes.length) {
        this.roundSeen = new Set(this.visible);
        this.deck = this.shuffle(allIndexes.filter(index => !this.visible.includes(index)));
      }
      const unseenIndexes = allIndexes.filter(index => !this.visible.includes(index) && !this.roundSeen.has(index));
      this.deck = this.deck.filter(index => unseenIndexes.includes(index));
      if (!this.deck.length) this.deck = this.shuffle(unseenIndexes);
      return this.deck[0] ?? null;
    }

    async change() {
      if (this.busy || this.held || this.motion.matches || document.hidden || this.contains(document.activeElement)) return;
      const next = this.nextCardIndex();
      if (next === null) return;
      const slotIndex = this.turn % this.slots.length;
      const slot = this.slots[slotIndex];
      const old = slot.querySelector('.antiguo-showcase__card');
      const incoming = this.cloneCard(next);
      incoming.classList.add('antiguo-showcase__card--incoming');
      incoming.setAttribute('aria-hidden', 'true');
      incoming.setAttribute('tabindex', '-1');
      this.busy = true;
      const signal = this.controller.signal;
      const image = incoming.querySelector('img');
      if (typeof image?.decode === 'function') {
        let decodeTimeout;
        await Promise.race([
          image.decode().catch(() => undefined),
          new Promise(resolve => { decodeTimeout = window.setTimeout(resolve, 1500); })
        ]);
        window.clearTimeout(decodeTimeout);
      }
      if (signal.aborted) return;
      if (this.held || this.contains(document.activeElement)) { this.busy = false; return; }
      slot.append(incoming);
      incoming.getBoundingClientRect();
      incoming.classList.add('antiguo-showcase__card--visible');
      this.midpoint = window.setTimeout(() => {
        incoming.classList.add('antiguo-showcase__card--clickable');
        old.style.pointerEvents = 'none';
      }, 800);
      this.finish = window.setTimeout(() => {
        old.remove();
        incoming.classList.remove('antiguo-showcase__card--incoming', 'antiguo-showcase__card--visible', 'antiguo-showcase__card--clickable');
        incoming.removeAttribute('aria-hidden');
        incoming.removeAttribute('tabindex');
        this.visible[slotIndex] = next;
        this.roundSeen.add(next);
        this.deck = this.deck.filter(index => index !== next);
        slot.dataset.showcaseIndex = String(next);
        this.turn += 1;
        this.busy = false;
      }, 1650);
    }

    stop() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.midpoint);
      window.clearTimeout(this.finish);
      this.controller?.abort();
      this.layoutObserver?.disconnect();
    }

    disconnectedCallback() { this.stop(); }
  });
}
